import React from 'react';
import styled from 'styled-components';
import { Seo } from "../../components/seo"
import Layout from "../../components/layout"
import Hero from "../../components/clearout-vs-dropcontact/pages-component/hero";
import DropcontactAlternatives from '../../components/clearout-vs-dropcontact/pages-component/dropcontact-alternatives';
import Accurate from '../../components/clearout-vs-dropcontact/pages-component/accurate';
import Greylisting from '../../components/clearout-vs-dropcontact/pages-component/anti-greylisting';
import Advanced from '../../components/clearout-vs-dropcontact/pages-component/advanced';
import RealTimeDatabase from '../../components/clearout-vs-dropcontact/pages-component/real-time-db';
import Accuracy from '../../components/clearout-vs-dropcontact/pages-component/accuracy';
import Features from '../../components/clearout-vs-dropcontact/pages-component/features';
import Cta from '../../components/clearout-vs-dropcontact/pages-component/cta';
import Testimonials from '../../components/home/pages-component/testimonials'
import JsonLd from "../../components/helper";

const StyledHome = styled("div")`
`;

const logoUrl  = "https://clearout.io/wp-content/uploads/2018/01/Clearout_Logo.png";

const ClearoutVsDropcontact = () => {
  let schema_data = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Clearout vs Dropcontact - Sales Prospecting Comparison",
    "url": "https://clearout.io/clearout-vs-dropcontact/",
    "description": "Compare Clearout and Dropcontact across their pricing, accuracy, features, and more.",
    "publisher": {
      "@type": "Organization",
      "name": "Clearout",
      "logo": {
        "@type": "ImageObject",
        "url": logoUrl,
        "width": 120,
        "height": 120
      }
    }
  }
   return (
      <Layout>
         <StyledHome>
            <section className="py-5 hero-section">
               <Hero />
            </section>
            <section className="py-3">
               <DropcontactAlternatives />
            </section>
            <section className="py-3">
               <Accurate />
            </section>
            <section className="py-3">
               <Greylisting />
            </section>
            <section className="py-4">
               <Advanced />
            </section>
            <section className="py-2">
               <RealTimeDatabase />
            </section>
            <section className="py-5">
               <Accuracy />
            </section>
            <section className="py-5">
               <Features />
            </section>
            <section className="py-2">
               <Testimonials />
            </section>
            <section className="py-3">
               <Cta />
            </section>
            <JsonLd data={schema_data} />
         </StyledHome>
      </Layout>
   )
}

export default ClearoutVsDropcontact;

export const Head = () => (
   <Seo
      title="#1 Dropcontact Alternative | Clearout Sales Prospecting"
      description="Looking for a reliable Dropcontact alternative? Find out why Clearout is the #1 Alternative to Dropcontact for your email finder and data enrichment needs."
      keywords="dropcontact alternative, compare dropcontact, alternative to dropcontact"
   />
);
